module.exports = __webpack_public_path__ + "img/mind_background_8.86ce3222.png";